export default __webpack_public_path__ + "static/media/hht1_ep18_book_wp_02.0dcfdc81.jpg";